const initialState = {
  baseUrlSteponeWS: ''
};

const baseUrlSteponeWSReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'SET_BASE_URL_STEPONE_WS':
          return { ...state, baseUrlSteponeWS: action.payload };
      default:
          return state;
  }
};

export default baseUrlSteponeWSReducer;
